<template>
  <div
    :class="['new-search-country-con', isApiDropdownShow ? 'is-focused' : '']"
  >
    <!-- 数据服务 -->
    <div
      class="dataService-nodropdown"
      v-if="$route.meta.title == 'DataServicesIndex'"
    >
      <i
        class="iconfont icon-search left-icon-search"
        v-if="isApiDropdownShow"
      ></i>
    </div>
    <!-- 选择国家 -->
    <div
      class="country-dropdown country-test"
      @click.stop="isCountryShow = !isCountryShow"
      v-else-if="
        $route.meta.title == 'NewsIndex' ||
        $route.meta.title == 'NewsList' ||
        $route.path.includes('riskScanning')
      "
    >
      <span class="select-country-con">
        <template
          v-if="
            selectCountryObj.countryCode == null ||
            selectCountryObj.countryCode == '' ||
            selectCountryObj.countryCode == 'undefined'
          "
        >
          <span class="country-placeholder">{{ $t("Home.selectCountry") }}</span>
        </template>
        <template v-else>
          <img :src="selectCountryObj.urlBanner" class="select-country-img" />
          <span class="select-country-name">{{ selectCountryObj.nameEn }}</span>
        </template>
        <i
          class="iconfont icon-jiantouxia"
          :class="{ 'country-arrow': isCountryShow }"
        ></i>
      </span>
    </div>

    <!-- ubo选择框 -->
    <div
      class="sanction-dropdown"
      @click.stop="isUboShow = !isUboShow"
      v-else-if="
        $route.meta.title == 'UboList' || $route.meta.title == 'UboDetail'
      "
    >
      <span class="select-country-con">
        <span class="select-country-name">{{ currentSelect }}</span>
        <i
          class="iconfont icon-jiantouxia"
          :class="{ 'country-arrow': isSanctionShow }"
        ></i>
      </span>
    </div>
    <!-- 联络挖掘选择框 -->
    <div
      class="sanction-dropdown"
      @click.stop="isLeadShow = !isLeadShow"
      v-else-if="$route.meta.title == 'Contact'"
    >
      <span class="select-country-con">
        <span class="select-country-name">{{ currentSelect }}</span>
        <i
          class="iconfont icon-jiantouxia"
          :class="{ 'country-arrow': isSanctionShow }"
        ></i>
      </span>
    </div>

    <!-- 制裁选择框 -->
    <div
      class="sanction-dropdown"
      @click.stop="isSanctionShow = !isSanctionShow"
      v-else
    >
      <span class="select-country-con">
        <span class="select-country-name">{{
          selectSanctionObj.sanctionName
        }}</span>
        <i
          class="iconfont icon-jiantouxia"
          :class="{ 'country-arrow': isSanctionShow }"
        ></i>
      </span>
    </div>
    <div id="gfdd55" v-if="$route.meta.title !== 'DataServicesIndex'">
      <svg
        id="idJleBSA"
        class="icon"
        t="1716874034454"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="4808"
        width="1.78em"
        height="1.78em"
      >
        <path
          id="idh7f1d4"
          d="M863.38 825.09L714.17 675.88c48.01-57.12 74.18-128.58 74.18-204.08 0-84.89-33.06-164.7-93.08-224.72C635.24 187.05 555.44 154 470.55 154c-84.89 0-164.7 33.06-224.72 93.08s-93.08 139.83-93.08 224.72 33.06 164.7 93.08 224.72 139.83 93.08 224.72 93.08c76.22 0 148.33-26.67 205.72-75.56l149.08 149.08a26.805 26.805 0 0 0 19.01 7.88c6.88 0 13.76-2.63 19.01-7.88a26.805 26.805 0 0 0 7.88-19.01c0-6.89-2.62-13.77-7.87-19.02zM206.53 471.8c0-145.58 118.44-264.02 264.02-264.02 145.58 0 264.02 118.44 264.02 264.02S616.13 735.82 470.55 735.82c-145.58 0-264.02-118.44-264.02-264.02z"
          fill="#8497AB"
          p-id="4809"
        ></path>
      </svg>
    </div>
    <!--  -->

    <!-- 带下拉框模糊搜索输入框 -->
    <el-autocomplete
      v-if="
        selectSanctionObj.sanctionCode == '4' &&
        $route.name != 'newsIndex' &&
        $route.name != 'dataServicesIndex' &&
        !$route.path.includes('ubo') &&
        !$route.path.includes('riskScanning')
      "
      id="c308fb"
      clearable
      v-model="searchKeyword"
      style="width: 100%; height: auto"
      :highlight-first-item="true"
      :debounce="300"
      :trigger-on-focus="false"
      :autofocus="true"
      class="search-country-input"
      @select="handleSelect"
      :fetch-suggestions="querySearchAsync"
      :placeholder="placeholder"
      size="large"
    >
    </el-autocomplete>
    <!-- 公司检索专用 -->
    <div
      v-else-if="$route.path.includes('riskScanning')"
      class="header_search_box"
    >
      <el-input
        v-model="searchKeyword"
        clearable
        class="search-country-input"
        :placeholder="$t('MyDatabase.Entercompanyname')"
        @keyup.enter.native="onSearchBtn()"
      />
      <div class="head_swi_keyword">
        <el-switch v-model="isKeywordActive"></el-switch>
        <span v-if="isKeywordActive == true" class="switch_txt">{{
          $t("Home.keWord")
        }}</span>
        <span v-else class="switch_txt">{{ $t("Home.firstWord") }}</span>
      </div>
    </div>

    <!-- dataservice模块的检索 -->
    <!-- <el-input
      v-else-if="$route.path.includes('dataServices')"
      v-model="searchKeyword"
      class="search-country-input"
      :placeholder="placeholder"
      @keyup.enter.native="onSearchBtn()"
    ></el-input> -->
    <el-cascader
      v-else-if="$route.path.includes('dataServices')"
      ref="searchCascader"
      :placeholder="placeholder"
      :options="twoLevelTreeDimension"
      :props="{ emitPath: false }"
      :filter-method="handleCascaderFilter"
      :show-all-levels="false"
      :class="['dataservices-cascader search-country-input']"
      v-model="searchKeyword"
      filterable
      @change="toApiDetail"
      @visible-change="isApiCascaderVisibleChange"
      popper-class="dataservices-popper"
    ></el-cascader>
    <!-- 普通检索 -->
    <el-input
      v-else
      v-model="searchKeyword"
      class="search-country-input"
      :placeholder="placeholder"
      @keyup.enter.native="onSearchBtn()"
    ></el-input>

    <el-button
      type="primary"
      round
      v-if="$route.meta.type == 'index'"
      :class="[
        'search-country-btn',
        this.$route.name == 'newsIndex'
          ? 'NewsBack'
          : this.$route.name == 'dataServicesIndex'
          ? 'DataServiceBack'
          : 'RiskBack',
        isApiDropdownShow ? 'apiSearchBtn' : '',
      ]"
      @click="onSearchBtn"
      ><i class="iconfont icon-search" v-if="!isApiDropdownShow"></i
      >Search</el-button
    >
    <div class="search-btnBox" v-else>
      <svg
        id="c1217c"
        class="icon icon_fangdajing"
        t="1716874034454"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="4808"
        @click="onSearchBtn"
      >
        <path
          id="c8de55"
          d="M863.38 825.09L714.17 675.88c48.01-57.12 74.18-128.58 74.18-204.08 0-84.89-33.06-164.7-93.08-224.72C635.24 187.05 555.44 154 470.55 154c-84.89 0-164.7 33.06-224.72 93.08s-93.08 139.83-93.08 224.72 33.06 164.7 93.08 224.72 139.83 93.08 224.72 93.08c76.22 0 148.33-26.67 205.72-75.56l149.08 149.08a26.805 26.805 0 0 0 19.01 7.88c6.88 0 13.76-2.63 19.01-7.88a26.805 26.805 0 0 0 7.88-19.01c0-6.89-2.62-13.77-7.87-19.02zM206.53 471.8c0-145.58 118.44-264.02 264.02-264.02 145.58 0 264.02 118.44 264.02 264.02S616.13 735.82 470.55 735.82c-145.58 0-264.02-118.44-264.02-264.02z"
          fill="#1A2332"
          p-id="4809"
        ></path>
      </svg>
    </div>

    <!-- 选择国家 -->
    <div
      ref="countryRef"
      class="country-popper"
      :class="{ 'country-show-popper': isCountryShow }"
    >
      <div class="country-popper-arrow"></div>
      <div class="country-popper-con">
        <div class="state-con">
          <div
            class="country-state-item"
            :class="{ activeState: selectStateIndex == index }"
            v-for="(item, index) in stateList"
            :key="index"
            @click="onChangeState(index)"
          >
            <span class="country-name">{{ item.continent.enName }}</span>
            <span class="country-countryCount">{{
              item.continent.countryNumStr
            }}</span>
          </div>
        </div>
        <div class="state-country-con">
          <div
            class="state-country-item"
            v-for="(item, index) in stateCountryList"
            :key="index"
            :class="{
              activeCountry: selectCountryObj.countryCode == item.countryCode,
            }"
            @click="selectCountryObjFn(item)"
          >
            <div class="state-country-item-con">
              <img :src="item.urlBanner" />
              <div class="state-country-info">
                <div class="state-country-name">{{ item.nameEn }}</div>
                <div class="state-country-companyCount">
                  {{ item.companyNumStr }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 选择制裁下拉框 -->
    <div
      ref="sanctionRef"
      class="sanction-popper"
      :class="{ 'sanction-show-popper': isSanctionShow }"
    >
      <div
        class="sanction-item-con"
        v-for="(item, index) in sanctionList"
        :key="index"
        :class="{
          activeSanction: selectSanctionObj.sanctionCode == item.dictDataCode,
        }"
        @click="onSelectSanction(item)"
      >
        {{ item.dictDataName }}
      </div>
    </div>
    <!-- ubo下拉框 -->
    <div
      ref="sanctionRef"
      class="sanction-popper"
      :class="{ 'sanction-show-popper': isUboShow }"
    >
      <div
        class="sanction-item-con"
        v-for="(item, index) in uboSelectList"
        :key="index"
        :class="{
          activeSanction: currentSelect == item,
        }"
        @click="onSelectUbo(item)"
      >
        {{ item }}
      </div>
    </div>
    <!-- 联络挖掘下拉框 -->
    <div
      ref="sanctionRef"
      class="sanction-popper lead_select"
      :class="{ 'sanction-show-popper': isLeadShow }"
    >
      <div
        class="sanction-item-con"
        v-for="(item, index) in leadSelectList"
        :key="index"
        :class="{
          activeSanction: currentSelect == item,
        }"
        @click="onSelectUbo(item)"
      >
        {{ item }}
      </div>
    </div>
    <!-- 登录弹窗 -->
    <Login :loginAndCreatePop.sync="loginDialog"></Login>
  </div>
</template>

<script>
import Login from "@/components/login.vue";
import { getCountryCollection } from "@/api/companyApi.js";
import { getApiCatalogueTree } from "@/api/dataServicesApi";
export default {
  props: {
    // 是否头部
    isHeader: {
      type: Boolean,
      default: false,
    },
    // 默认信息
    countryCode: {
      type: String,
      default: "",
    },
    // 关键字
    keyword: {
      type: String,
      default: "",
    },
  },
  components: { Login },
  data() {
    return {
      treeDimension: [],
      loginDialog: false,
      isKeywordActive:
        this.$route.query.keword == 2 || this.$route.query.keword == undefined
          ? true
          : false,
      placeholder: this.$t("Home.EnterKeyword"),
      searchKeyword: "", //搜索关键字
      isCountryShow: false, //选择国家提示框
      isSanctionShow: false, //选择制裁提示框
      selectCountryObj: {
        countryCode: "",
      },
      selectStateIndex: 0,
      countryCodeRisk: "",
      stateList: [], // 州列表
      stateCountryList: [], //选择州下的国家
      stateCountryListCopy: [], //选择州下的国家
      selectSanctionObj: {
        sanctionCode: "4",
        sanctionName: "Country",
      },
      sanctionList: [
        {
          dictDataCode: "4",
          dictDataName: "Country",
        },
        {
          dictDataCode: "1",
          dictDataName: "Company",
        },
        {
          dictDataCode: "2",
          dictDataName: "Person",
        },
        {
          dictDataCode: "3",
          dictDataName: "Product",
        },
      ],

      currentSelect: "Company",
      isUboShow: false, //选择制裁提示框
      uboSelectList: ["Company", "Product"],

      isLeadShow: false, //联络挖掘提示框
      leadSelectList: [
        "Standard Industry Code (SIC)",
        "HS Code",
        // "Global Product Classification(GPC)",
        "Product Keyword",
        "AI Assistance",
      ],
      isApiDropdownShow: false,
      closeTimer: null,
    };
  },
  computed: {
    // ✅ 只取前两层
    twoLevelTreeDimension() {
      return this.treeDimension.map((level1) => {
        if (level1.children) {
          // 保留 label 和 value
          const level2WithoutChildren = level1.children.map((level2) => {
            return {
              value: level2.id,
              label: level2.name,
            };
          });
          return {
            value:  `root-${level1.id}`,// 生成父节点的唯一 ID (例如: "root-1") 防止与子级id重复 选中时页面不回显问题
            label: level1.name,
            children: level2WithoutChildren,
          };
        }
        return level1;
      });
    },
  },
  methods: {
    // 下拉框展示隐藏
    isApiCascaderVisibleChange(val) {
      this.isApiDropdownShow = val;
      if (!val) return;
      // 默认显示第一级的子级
      // 1. 获取下拉框面板元素 (使用你定义的 popper-class)
      const popper = document.querySelector(".dataservices-popper");
      if (!popper) return;

      // 2. 找到第一级的菜单列表
      // Element UI 的结构通常是：.el-cascader-menu (第一列) -> .el-cascader-node
      const firstMenu = popper.querySelector(".el-cascader-menu");
      if (!firstMenu) return;

      // 3. 找到第一级的第一个节点 (或者你可以遍历所有节点)
      const firstNode = firstMenu.querySelector(".el-cascader-node");

      if (firstNode) {
        // 4. 【关键】模拟鼠标移入事件，触发子级显示
        // 注意：必须使用 'mouseenter' 或 'mouseover'，且 bubbles: true
        const event = new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
        });
        firstNode.dispatchEvent(event);
      }
      const input = this.$refs.searchCascader?.$el.querySelector("input");
      if (input) input.focus();

      if (!val) {
        // 当组件试图关闭时
        // 1. 清除之前的关闭定时器
        if (this.closeTimer) clearTimeout(this.closeTimer);

        // 2. 设置延迟关闭
        this.closeTimer = setTimeout(() => {}, 600);
      } else {
        // 当组件打开时，清除关闭定时器
        if (this.closeTimer) clearTimeout(thisTimer);
      }
    },
    // 自定义搜索：支持搜任意层级的 label
    handleCascaderFilter(node, keyword) {
      if (!keyword || !node?.label) return false;

      try {
        const fullPath = this.getNodePathLabel(node);
        return fullPath.toLowerCase().includes(keyword.toLowerCase());
      } catch (e) {
        console.warn("Search error:", e);
        return node.label.toLowerCase().includes(keyword.toLowerCase());
      }
    },

    // 获取节点的完整路径 label，如 "亚洲 / 中国"
    getNodePathLabel(node) {
      let path = [node.label];
      let parent = node.parent;
      while (parent && parent.label) {
        path.unshift(parent.label);
        parent = parent.parent;
      }
      // console.log("path", path);
      return path.join(" / ");
    },
    // api 1 2 3级数据
    async getApiCatalogueTreeFn() {
      let arrData = localStorage.getItem("ApiCatalogueTreeData");
      if (arrData) {
        this.treeDimension = JSON.parse(
          localStorage.getItem("ApiCatalogueTreeData"),
        );
        console.log("获取树形结构DataDimension", this.treeDimension);
        return;
      }
      await getApiCatalogueTree().then((res) => {
        console.log("获取树形结构DataDimension", res);
        if (res.code == 200 && res.data.length > 0) {
          this.treeDimension = res.data;
          localStorage.setItem(
            "ApiCatalogueTreeData",
            JSON.stringify(res.data),
          );
        }
      });
    },
    // 国家制裁添加国家下拉取
    querySearchAsync(queryString, cb) {
      const token = localStorage.getItem("token");
      if (token) {
        if (queryString !== "") {
          let Allcountry = JSON.parse(localStorage.getItem("countryList"))[0]
            .countryList;
          Allcountry.forEach((item) => {
            item.value = item.nameEn;
            item.val = item.nameEn;
          });
          let SelecrCountry = queryString
            ? Allcountry.filter(this.createStateFilter(queryString))
            : Allcountry;
          cb(SelecrCountry);
        }
      } else {
        this.loginDialog = true;
        cb([]);
      }
    },
    createStateFilter(queryString) {
      return (state) => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    // 国家制裁
    handleSelect(item) {
      console.log(`item`, item);
      console.log(this.$route.meta.title);

      //  this.$store.commit("setRefreshKey", new Date().getTime());
      this.countryCodeRisk = item.countryCode;
      this.$router.push({
        path: "/sanction/countryList",
        query: {
          keyword: item.nameEn,
          CountryCode: this.countryCodeRisk,
          selectCode: 4,
        },
      });

      if (this.$route.meta.title != "SanctionIndex") {
        this.onSearchBtn();
      }
    },
    // 搜索框重级联选择选中 跳转e二级api详情页
    toApiDetail(id) {
      if (this.$route.meta.title == "DataServicesIndex") {
        this.$router.push({
          name: "APIHomepage_more_detail",
          query: { id: id },
        });
      }
    },
    // 搜索
    onSearchBtn() {
      console.log("isApiDropdownShow", this.isApiDropdownShow);
      const token = localStorage.getItem("token");
      if (token) {
        let manualInput = ""; //输入框里的文字
        if (
          !this.searchKeyword &&
          this.$route.meta.title == "DataServicesIndex"
        ) {
          let inputEl = this.$refs.searchCascader.$el.querySelector("input");
          manualInput = inputEl ? inputEl.value : "";
        }
        // 判断输入框是否有值
        let isHasInputVal = this.searchKeyword
          ? true
          : manualInput
          ? true
          : false;

        if (!isHasInputVal) {
          this.$message({
            message: this.placeholder,
            center: true,
            type: "error",
          });
        } else {
          if (this.$route.meta.type == "index") {
            // 首页 进行跳转页面
            if (this.$route.meta.title == "NewsIndex") {
              this.$router.push({
                path: "/news/list",
                query: {
                  keyword: this.searchKeyword,
                  selectCode: this.selectCountryObj.countryCode,
                },
              });
            } else if (this.$route.meta.title == "DataServicesIndex") {
              console.log("跳转", this.isApiDropdownShow);

              // 首页 进行跳转页面
              this.$router.push({
                path: "/dataServices/list",
                query: {
                  keyword: manualInput,
                },
              });
            } else {
              if (this.selectSanctionObj.sanctionCode == "1") {
                // 公司
                this.$router.push({
                  path: "/sanction/companyList",
                  query: {
                    keyword: this.searchKeyword,
                    selectCode: 1,
                  },
                });
              } else if (this.selectSanctionObj.sanctionCode == "2") {
                // 个人
                this.$router.push({
                  path: "/sanction/personList",
                  query: {
                    keyword: this.searchKeyword,
                    selectCode: 2,
                  },
                });
              } else if (this.selectSanctionObj.sanctionCode == "3") {
                // 产品
                this.$router.push({
                  path: "/sanction/productList",
                  query: {
                    keyword: this.searchKeyword,
                    selectCode: 3,
                  },
                });
              } else if (this.selectSanctionObj.sanctionCode == "4") {
                // 国家
                this.$router.push({
                  path: "/sanction/countryList",
                  query: {
                    keyword: this.searchKeyword,
                    selectCode: 4,
                    CountryCode: this.countryCodeRisk,
                  },
                });
              }
            }
          } else {
            // 在列表页 进行检索
            let params;
            if (this.$route.meta.title == "NewsList") {
              params = {
                searchKeyword: this.searchKeyword,
                selectCode: this.selectCountryObj.countryCode,
              };
            } else if (this.$route.path.includes("riskScanning")) {
              // 检索公司时跳转到公司检索一览
              this.$router.push({
                path: "/index/search/list/" + this.searchKeyword + "/company",
                query: {
                  searchname: this.searchKeyword,
                  companyCountry: this.selectCountryObj.countryCode,
                  keword: this.isKeywordActive ? 2 : 1,
                },
              });
            } else {
              params = {
                searchKeyword: this.searchKeyword,
                selectCode: this.selectSanctionObj.sanctionCode,
                CountryCode: this.countryCodeRisk,
              };
              console.log(params);
            }
            this.$emit("searchFn", params, this.currentSelect);
          }
        }
      } else {
        this.loginDialog = true;
      }
    },
    //   获取国家列表
    async getCountryList() {
      if (localStorage.getItem("countryList")) {
        this.setCountryImg();
      } else {
        let res = await getCountryCollection();
        if (res && res.code) {
          this.$store.state.countryImgList = JSON.parse(
            localStorage.getItem("countryList"),
          );
          localStorage.setItem("countryList", JSON.stringify(res.data.rows));

          this.setCountryImg();
        }
      }
    },
    //   设置国家图片
    setCountryImg() {
      this.stateList = JSON.parse(localStorage.getItem("countryList"));
      this.stateList.map((item) => {
        item.countryList.map((itemC) => {
          if (itemC.urlBanner == null) {
            itemC.urlBanner = require("../../../static/imagev2/zanwutupian.png");
          } else {
            let getImageUrlPath = itemC.urlBanner.split("/static")[1];
            itemC.urlBanner = require("../../../static" + getImageUrlPath);
          }
        });
      });

      this.stateCountryList = this.stateList[0].countryList;
      // 信息参数不为空时赋值
      if (
        this.countryCode != "" &&
        this.countryCode != null &&
        this.countryCode != "undefined"
      ) {
        if (this.$route.meta.title == "NewsList") {
          this.selectCountryObj = this.stateCountryList.filter(
            (item) => item.countryCode == this.countryCode,
          )[0];
        } else {
          let filterData = this.sanctionList.filter(
            (item) => item.dictDataCode == this.countryCode,
          )[0];
          this.selectSanctionObj = {
            sanctionCode: filterData.dictDataCode,
            sanctionName: filterData.dictDataName,
          };
        }
      }
    },
    // 切换州
    onChangeState(index) {
      this.selectStateIndex = index;
      this.stateCountryList = this.stateList[index].countryList;
    },
    // 选择国家
    selectCountryObjFn(item) {
      this.selectCountryObj = item;
      this.isCountryShow = false;
      this.$emit("selectCountry", item.countryCode);
    },
    // 选择制裁类型
    onSelectSanction(item) {
      console.log(`item`, item);
      if (item.dictDataCode == "1") {
        this.placeholder = this.$t("MyDatabase.Entercompanyname");
      } else if (item.dictDataCode == "2") {
        this.placeholder = "Enter Person Name";
      } else if (item.dictDataCode == "3") {
        this.placeholder = this.$t('Relationship.Enterproductkeywords');
      } else if (item.dictDataCode == "4") {
        this.placeholder = "Enter Country Name";
      }
      this.searchKeyword = "";
      this.selectSanctionObj.sanctionCode = item.dictDataCode;
      this.selectSanctionObj.sanctionName = item.dictDataName;
      this.isSanctionShow = false;
    },
    // 选择ubo
    onSelectUbo(val) {
      if (val == "Company") {
        this.placeholder = this.$t("MyDatabase.Entercompanyname");
      }
      if (val == "Product") {
        this.placeholder = this.$t('Relationship.Enterproductkeywords');
      }
      this.searchKeyword = "";
      this.currentSelect = val;
      this.isUboShow = false;
    },
    handleClickOutside(event) {
      if (
        this.$route.meta.title == "NewsIndex" ||
        this.$route.meta.title == "NewsList"
      ) {
        let countryRef = this.$refs.countryRef;
        // 判断点击的区域是否在元素外部
        if (countryRef && !countryRef.contains(event.target)) {
          this.isCountryShow = false;
        }
      } else {
        let sanctionRef = this.$refs.sanctionRef;
        // 判断点击的区域是否在元素外部
        if (sanctionRef && !sanctionRef.contains(event.target)) {
          this.isSanctionShow = false;
          this.isUboShow = false;
        }
      }
    },
  },
  mounted() {
    if (
      this.$route.meta.title == "NewsIndex" ||
      this.$route.meta.title == "NewsList"
    ) {
      this.placeholder = this.$t("Home.EnterKeyword");
    } else if (this.$route.path == "/sanction/productList") {
      this.placeholder = this.$t('Relationship.Enterproductkeywords');
      this.selectSanctionObj.sanctionCode = 3;
    } else if (this.$route.path == "/sanction/personList") {
      this.placeholder = "Enter Person Name";
      this.selectSanctionObj.sanctionCode = 2;
    } else if (
      this.$route.path == "/sanction/companyList" ||
      this.$route.path == "/sanction/home"
    ) {
      this.placeholder = this.$t("MyDatabase.Entercompanyname");
      this.selectSanctionObj.sanctionCode = 1;
    } else if (
      this.$route.path == "/sanction/countryList" ||
      this.$route.query.selectCode == 4
    ) {
      this.placeholder = "Enter Country Name";
      this.selectSanctionObj.sanctionCode = 4;
    } else if (this.$route.path == "/dataServices/index") {
      this.placeholder = "Enter API name";
    } else {
      this.currentSelect = this.$route.query.selectKey;
    }

    this.getCountryList();
    this.searchKeyword = this.keyword;
    document.addEventListener("click", this.handleClickOutside);

    this.getApiCatalogueTreeFn(); //调一次存起来
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style scoped>
.dataservices-cascader.search-country-input >>> .el-input__inner{
  line-height: 64px;
}
.new-search-country-con.is-focused {
  border-radius: 40px 40px 0 0;
  border-left: 3px solid #b98b73;
  border-top: 3px solid #b98b73;
  border-right: 3px solid #b98b73;
}
.new-search-country-con.is-focused .search-country-input {
  padding: 0 20px 0 30px;
}
.search-country-btn.apiSearchBtn {
  width: 105px;
  height: 36px;
  margin: 0 15px 0 15px;
  border-radius: 35px;
}
.new-search-country-con.is-focused .left-icon-search.icon-search:before {
  font-size: 24px;
  font-weight: bold;
  color: #b98b73;
  margin-left: 15px;
}
.dataService-nodropdown {
  width: 15px;
}

.country-dropdown,
.sanction-dropdown {
  position: relative;
  width: 210px;
  border-radius: 27px 0 0 27px;
  margin-right: 10px;
}

.country-dropdown::after,
.sanction-dropdown::after {
  content: "";
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 30px;
  background: #dddddd;
}

.select-country-con {
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  padding: 0 14px 0 20px;
  cursor: pointer;
}

.select-country-con .country-placeholder {
  flex: 1;
  font-size: 16px;
}

.select-country-con i {
  font-size: 16px;
  color: #1a2332;
  transition: all 0.3s;
}

.country-arrow {
  transform: rotate(180deg);
}

.select-country-img {
  width: 36px;
  height: 22px;
  margin-right: 6px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.2);
}

.select-country-name {
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-right: 6px;
  line-height: 20px;
  font-size: 16px;
  color: #1a2332;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sanction-dropdown .select-country-name {
  font-size: 1.28571428571428rem;
}

.country-popper {
  position: absolute;
  top: 84px;
  left: 0;
  width: 1000px;
  height: 300px;
  padding: 18px 5px 0px 0;
  margin-top: 0 !important;
  background: #ffffff;
  box-shadow: 0px -8px 20px 0px rgba(10, 33, 57, 0.24);
  border-radius: 12px;
  z-index: -1;
  opacity: 0;
  pointer-events: none;
  transition: all 0.3s ease-in-out;
}

.country-show-popper {
  width: 1178px;
  height: 378px;
  opacity: 1;
  z-index: 9;
  pointer-events: all;
  transition: all 0.3s ease-in-out;
}

.sanction-popper {
  position: absolute;
  top: 74px;
  left: 0;
  width: 200px;
  height: auto;
  padding: 12px 0;
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  z-index: -1;
  opacity: 0;
  transform: perspective(300px) rotateX(-10deg);
  transform-origin: 50% 0;
  pointer-events: none;
  transition: all 0.3s ease-in-out;
}

.sanction-show-popper {
  opacity: 1;
  z-index: 9;
  pointer-events: all;
  transform: rotateX(0deg);
}

.sanction-item-con {
  width: 100%;
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
  font-size: 20px;
  color: #1a2332;
  cursor: pointer;
}

.sanction-item-con:not(:last-child) {
  margin-bottom: 4px;
}

.sanction-item-con:hover,
.sanction-item-con.activeSanction {
  color: #f9722c;
  background: #f5f5f5;
}

.sanction-theme .sanction-item-con:hover,
.sanction-theme .sanction-item-con.activeSanction {
  color: #f9722c;
  background: #f5f5f5;
}

.country-popper-arrow,
.country-popper-arrow::after {
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}

.country-popper-arrow {
  left: 60px;
  top: -12px;
  border-width: 12px;
  border-top-width: 0;
  border-bottom-color: #ffffff;
}

.country-popper-arrow::after {
  content: "";
  border-width: 12px;
  border-bottom-color: #ffffff !important;
  filter: drop-shadow(0px -8px 20px 0px rgba(10, 33, 57, 0.24)) !important;
}

.country-popper-con {
  display: flex;
  height: 100%;
  overflow: hidden;
}

.country-popper-con .state-con {
  width: 220px;
  height: calc(100% - 18px);
  flex-shrink: 0;
  border-right: 1px solid #dddddd;
  overflow: auto;
}

.country-popper-con .country-state-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 42px;
  padding: 0 20px;
  cursor: pointer;
}

.country-popper-con .country-state-item:not(:last-child) {
  margin-bottom: 8px;
}

.country-popper-con .country-name {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

  font-size: 16px;
  color: #1a2332;
}

.country-popper-con .country-state-item.activeState {
  background: #f5f5f5;
}

.country-popper-con .country-state-item:hover .country-name,
.country-popper-con .country-state-item.activeState .country-name {
  color: #1290c9;
}

.news-theme .country-popper-con .country-state-item:hover .country-name,
.news-theme .country-popper-con .country-state-item.activeState .country-name {
  color: #3ebb72;
}

.country-popper-con .country-countryCount {
  width: 30px;
  font-size: 14px;
  color: #999999;
  text-align: right;
}

.country-popper-con .state-country-con {
  width: 953px;
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  align-content: flex-start;
  padding-left: 20px;
  overflow: auto;
}

.country-popper-con .state-country-item {
  width: 222px;
  height: 56px;
  padding: 8px 10px;
  margin-bottom: 10px;
  background: #f5f5f5;
  border: 1px solid #f5f5f5;
  cursor: pointer;
}

.country-popper-con .state-country-item-con {
  display: flex;
  align-items: center;
  justify-content: start;
}

.country-popper-con .state-country-item:hover,
.country-popper-con .state-country-item.activeCountry {
  border-color: #1290c9;
}

.news-theme .country-popper-con .state-country-item:hover,
.news-theme .country-popper-con .state-country-item.activeCountry {
  border-color: #3ebb72;
}

.country-popper-con .state-country-item:not(:nth-child(4n)) {
  margin-right: 10px;
}

.country-popper-con .state-country-item img {
  width: 56px;
  height: 34px;
  margin-right: 6px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.2);
}

.country-popper-con .state-country-info {
  flex: 1;
  overflow: hidden;
}

.country-popper-con .state-country-name {
  line-height: 20px;
  margin-bottom: 4px;
  font-size: 16px;
  color: #1a2332;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.country-popper-con .state-country-companyCount {
  font-size: 14px;
  color: #999999;
  line-height: 1;
}

.search-country-input.dataservices-cascader >>> .el-input__suffix {
  display: none;
}

.search-country-input {
  flex: 1;
  padding: 0 10px;
}

.search-country-input >>> .el-input__inner {
  line-height: 70px;
  font-size: 16px;
  padding: 0 !important;
  color: #1a2332;
  border: none !important;
  border-radius: 0;
}

.search-country-input >>> .el-input__inner::placeholder {
  color: #8497ab;
}

.search-country-btn {
  position: relative;
  left: 1px;
  display: flex;
  align-items: center;
  width: 150px;
  height: 70px;
  margin: 0 0 0 15px;
  font-size: 18px;
  color: #ffffff;
  background: #1290c9;
  border-radius: 0px 35px 35px 0px;
}

.search-country-btn >>> span {
  display: flex;
  align-items: center;
}

.search-country-btn i {
  font-size: 40px;
}

.page-top-con .new-search-country-con {
  position: absolute;
  left: 0;
  right: 0;
  top: 17px;
  width: 700px;
  height: 54px;
  margin: auto;
  box-shadow: none;
  border-radius: 27px;
  z-index: 999;
}

.page-top-con .select-country-img {
  width: 34px;
  height: 20px;
}

.page-top-con .select-country-name {
  line-height: 20px;
  font-size: 18px;
}

.page-top-con .select-country-con i {
  font-size: 16px;
}

.page-top-con .search-country-input {
  padding: 0 10px;
}

.page-top-con .search-country-input >>> .el-input__inner {
  line-height: 54px;
  font-size: 16px;
}

.page-top-con .new-search-country-con .icon-search {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  font-size: 26px;
}

.page-top-con .new-search-country-con .search-btn {
  color: #1a2332;
  cursor: pointer;
}

.page-top-con .country-popper {
  top: 68px;
}

.page-top-con .sanction-dropdown .select-country-name {
  line-height: 1;
  font-size: 16px;
}

.page-top-con .sanction-popper {
  top: 58px;
}

.header_search_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
}

::v-deep .header_search_box .el-switch__core {
  border-color: #1290c9 !important;
  background-color: #1290c9 !important;
}
#gfdd55 {
  height: 30px;
  display: flex;
  align-items: center;
}
.search-btnBox {
  width: 50px;
  height: 30px;
  padding-right: 20px;
}
.icon_fangdajing {
  width: 30px;
  height: 30px;
}
.head_swi_keyword {
  position: relative;
  margin-right: 20px;
}
.head_swi_keyword /deep/ .el-switch {
  height: 40px;
  line-height: 40px;
}
.head_swi_keyword /deep/ .el-switch__core {
  width: 100px !important;
  height: 40px;
  border-radius: 20px;
  border: none;
}
.head_swi_keyword /deep/ .el-switch.is-checked .el-switch__core {
  background: #1290c9;
}
.head_swi_keyword /deep/ .el-switch__core:after {
  top: 2px;
  left: 1px;
  width: 36px;
  height: 36px;
  background: #ffffff;
}
.head_swi_keyword /deep/ .el-switch.is-checked + .switch_txt {
  top: 50%;
  transform: translate(-80%, -50%);
  left: 50%;
}
.switch_txt {
  position: absolute;
  left: 40px;
  top: 5px;
  font-size: 14px;
  color: #ffffff;
  line-height: 14px;
}
.head_swi_keyword /deep/ .el-switch.is-checked .el-switch__core::after {
  margin-left: 0 !important;
  left: 63px !important;
}
.lead_select {
  width: 350px;
}
@media (max-width: 1920px) {
  .dataservices-cascader.search-country-input >>> .el-input__inner{
  line-height: 46px;
}
  .apiSearchBtn.search-country-btn{
    padding:0 0 0 30px;
  }

  .country-dropdown,
  .sanction-dropdown {
    width: 160px;
    border-radius: 20px 0 0 20px;
  }

  .country-dropdown::after,
  .sanction-dropdown::after {
    height: 22px;
  }

  .select-country-con {
    padding: 0 10px 0 15px;
  }

  .select-country-con .country-placeholder {
    font-size: 14px;
  }

  .select-country-img {
    width: 26px;
    height: auto;
    margin-right: 4px;
  }

  .select-country-name {
    margin-right: 2px;
    line-height: 14px;
    font-size: 14px;
  }

  .sanction-dropdown .select-country-name {
    font-size: 14px;
  }

  .country-popper {
    top: 58px;
    width: 750px;
    height: 200px;
    padding: 10px 3px 10px 0;
    border-radius: 4px;
  }

  .country-show-popper {
    width: 850px;
    height: 264px;
  }

  .sanction-popper {
    top: 58px;
    width: 160px;
    padding: 8px 0;
    border-radius: 4px;
  }

  .country-popper-arrow {
    left: 35px;
    top: -6px;
    border-width: 6px;
    border-top-width: 0;
    border-bottom-color: #ffffff;
  }

  .country-popper-arrow::after {
    border-width: 8px;
  }

  .country-popper-con .state-con {
    width: 218px;
    height: 100%;
  }

  .country-popper-con .country-state-item {
    height: 40px;
    padding: 0 14px;
  }

  .country-popper-con .country-state-item:not(:last-child) {
    margin-bottom: 0px;
  }

  .country-popper-con .country-name {
    line-height: 14px;
    font-size: 14px;
  }

  .country-popper-con .country-countryCount {
    flex-shrink: 0;
    width: 20px;
    font-size: 12px;
  }

  .country-popper-con .state-country-con {
    width: 640px;
    padding-left: 10px;
  }

  .country-popper-con .state-country-item {
    width: 148px;
    height: 40px;
    padding: 4px 6px;
    margin-bottom: 6px;
  }

  .country-popper-con .state-country-item:not(:nth-child(4n)) {
    margin-right: 6px;
  }

  .country-popper-con .state-country-item img {
    width: 38px;
    height: 22px;
    margin-right: 4px;
  }

  .country-popper-con .state-country-name {
    line-height: 14px;
    margin-bottom: 2px;
    font-size: 14px;
  }

  .country-popper-con .state-country-companyCount {
    font-size: 12px;
  }

  .sanction-item-con {
    height: 30px;
    line-height: 30px;
    padding: 0 15px;
    font-size: 16px;
  }

  .sanction-item-con:not(:last-child) {
    margin-bottom: 2px;
  }

  .search-country-input {
    padding: 0 10px;
  }

  .search-country-input >>> .el-input__inner {
    line-height: 46px;
    font-size: 14px !important;
  }

  .search-country-btn {
    width: 110px;
    height: 50px;
    margin-left: 0;
    padding: 0 0 0 10px;
    font-size: 14px;
    border-radius: 0px 26px 26px 0px;
  }

  .search-country-btn i {
    font-size: 26px;
    margin-right: 5px;
  }

  .page-top-con .new-search-country-con {
    width: 700px;
    height: 40px;
    border-radius: 20px;
    top: 13px;
  }

  .page-top-con .select-country-img {
    width: 22px;
    height: 14px;
  }

  .page-top-con .select-country-name {
    line-height: 16px;
    font-size: 14px;
  }

  .page-top-con .select-country-con i {
    font-size: 16px;
  }

  .page-top-con .search-country-input >>> .el-input__inner {
    line-height: 36px;
    font-size: 14px;
  }

  .page-top-con .new-search-country-con .icon-search {
    width: 14px;
    height: 14px;
    font-size: 18px;
  }

  .page-top-con .country-popper {
    top: 45px;
  }

  .page-top-con .sanction-dropdown .select-country-name {
    font-size: 14px;
    line-height: 18px;
  }

  .page-top-con .sanction-popper {
    top: 43px;
  }

  #gfdd55 {
    height: 26px;
  }
  .search-btnBox {
    width: 41px;
    height: 26px;
    padding-right: 15px;
  }
  .icon_fangdajing {
    width: 26px;
    height: 26px;
  }
  .head_swi_keyword {
    margin-right: 15px;
  }
  .head_swi_keyword /deep/ .el-switch {
    height: 32px;
    line-height: 32px;
  }
  .head_swi_keyword /deep/ .el-switch__core {
    width: 90px !important;
    height: 32px;
    border-radius: 16px;
  }
  .head_swi_keyword /deep/ .el-switch__core:after {
    top: 1px;
    left: 1px;
    width: 30px;
    height: 30px;
  }
  .head_swi_keyword /deep/ .el-switch.is-checked .el-switch__core::after {
    left: 59px !important;
  }
  .switch_txt {
    left: 40px;
    top: 5px;
    font-size: 12px;
    line-height: 12px;
  }
  .lead_select {
    width: 280px;
  }
}

.NewsBack {
  background-color: #3ebb72 !important;
}

.RiskBack {
  background-color: #f9722c !important;
}

.DataServiceBack {
  background-color: #b98b73 !important;
}
</style>
